import http from 'hub-http/clients/apiClient';
export const getIdentificationToken = () => {
  return http.post('zorse/v2/messages/tokens/create');
};